<template>
  <div class="message-grid-row">
    <!-- Bot message column -->
    <div class="message-col bot">
      <BaseSkeleton
        type="text"
        width="80%"
      />
      <BaseSkeleton
        type="text"
        width="60%"
      />
    </div>

    <!-- Client history (middle) -->
    <div class="message-col user">
      <BaseSkeleton
        type="text"
        width="70%"
      />
      <BaseSkeleton
        type="text"
        width="40%"
      />
    </div>

    <!-- Case law documents -->
    <div class="message-col docs">
      <BaseSkeleton
        type="text"
        width="90%"
      />
      <BaseSkeleton
        type="text"
        width="50%"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import BaseSkeleton from '@/interfaces/components/skeletons/BaseSkeleton.vue';
</script>

<style scoped lang="sass">
  .message-grid-row
    display: grid
    grid-template-columns: 1fr 1fr 1fr
    gap: 16px
    margin-bottom: 24px

  .message-col
    display: flex
    flex-direction: column
    gap: 8px
</style>
